import { defineStore } from 'pinia'

const TOKEN_KEY = 'token'
const PROFILE_KEY = 'article_share_profile'

function loadProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function toProfile(data) {
  if (!data) return null
  return {
    id: data.id,
    username: data.username,
    nickname: data.nickname,
    avatar: data.avatar,
    is_advanced: Number(data.is_advanced) === 1
  }
}

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '',
    profile: null
  }),
  getters: {
    isLogin: (state) => Boolean(state.token && state.profile),
    isAdvanced: (state) => Boolean(state.profile?.is_advanced),
    displayName: (state) => state.profile?.nickname || state.profile?.username || ''
  },
  actions: {
    hydrate() {
      this.token = localStorage.getItem(TOKEN_KEY) || ''
      this.profile = loadProfile()
    },
    setLogin(data) {
      this.token = data.token || ''
      this.profile = toProfile(data)
      if (this.token) localStorage.setItem(TOKEN_KEY, this.token)
      if (this.profile) localStorage.setItem(PROFILE_KEY, JSON.stringify(this.profile))
    },
    patchProfile(partial) {
      if (!this.profile) return
      this.profile = { ...this.profile, ...partial }
      localStorage.setItem(PROFILE_KEY, JSON.stringify(this.profile))
    },
    clearSession() {
      this.token = ''
      this.profile = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(PROFILE_KEY)
    },
    async logout() {
      try {
        const { logout } = await import('@/services/user')
        await logout()
      } catch {
        // ignore network errors on logout
      }
      this.clearSession()
    }
  }
})
